<template>
  <div class="space-top-desktop">
    <h1 style="text-align: center">Características</h1>
    <p style="margin-top: 10px; ">
      As grades SIBROL são constituídas por barras portantes em barras chatas e por barras secundárias em barras redondas ou chatas encaixadas e soldadas.
      <br />
      <br />São fornecidas em painéis de diversas dimensões, em qualquer formato, já com recortes e acabadas com requadros periféricos.
      <br />
      <br />Recomenda-se painéis com dimensões não superiores a 1,50m x 2,00m, visando facilidade de transporte e montagem. Para fixação dos painéis utiliza-se presilhas especiais
      SIBROL ou solda.
    </p>

    <b-row class="justify-content-center caract-wrap-img">
      <b-col sm="12" md="4">
        <img src="@/assets/images/serie25.jpg" class="img-fluid caract-serie" />
      </b-col>
      <b-col sm="12" md="4">
        <img src="@/assets/images/serie30.jpg" class="img-fluid caract-serie" />
      </b-col>
      <b-col sm="12" md="4">
        <img src="@/assets/images/serie35.jpg" class="img-fluid caract-serie" />
      </b-col>
    </b-row>
    <strong>Materiais:</strong>
    <br />Aço Carbono. <br />Aço Inoxidável.
    <br />
    <br />
    <strong>Acabamentos:</strong>
    <br />Superfície natural. <br />Superfície galvanizada a fogo, conforme norma NBR 6323 da ABNT. <br />Superfície pintada com primer e/ou pintura de acabamento após jato ou
    limpeza manual. <br />Para aplicações especiais, como em plataformas "off-shore", as barras portantes podem ser serrilhadas, para que se obtenha acabamento superficial
    anti-derrapante.
    <br />
    <br />Para grades serrilhadas, a altura das barras portantes, para a carga especifica, deve ser 5 mm maior que a indicada nas tabelas.
    <br />
    <br />Para consultar, mencionar os seguintes itens:
    <b-row>
      <b-col sm="12" md="6">
        <ul>
          <li>Tipo e malha -Exemplo: PSC 253-35x70</li>
          <li>Dimensões (Largura e comprimento)</li>
          <li>Desenho, em caso de grades com recortes</li>
          <li>Material</li>
        </ul>
      </b-col>
      <b-col sm="12" md="6">
        <ul>
          <li>Acabamento (natural, galvanizado ou pintado)</li>
          <li>Vão de apoio</li>
          <li>Superfície lisa ou anti-derrapante (Serrilhada)</li>
          <li>Material</li>
        </ul>
      </b-col> </b-row
    >Em situações onde houver passagem de veículos, informar:
    <ul>
      <li>Carga por roda</li>
      <li>Área de contato da roda com a grade</li>
    </ul>

    <b-row style="margin-top: 50px; text-align: center">
      <b-col sm="12" md="6">
        <img src="@/assets/images/img_grade3.jpg" class="img-fluid img-shadow-blue" />
      </b-col>
      <b-col sm="12" md="6">
        <img src="@/assets/images/img_grade5.jpg" class="img-fluid sec-img" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Caracteristicas",
  data() {
    return {
      content: null,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_standard.scss";

.img-shadow-blue {
  box-shadow: 10px -10px 0px $primary;
}

.sec-img {
  @media (max-width: 768px) {
    margin-top: 50px;
  }
}
</style>
